<template>
  <div class="aboutContainer">
    <full-page :options="options" ref="fullpage">
      <div class="section pageBox1">
        <!-- 导航 -->
        <div class="navBar">
          <img
            class="navLogo"
            src="../assets/logo.png"
            alt=""
            @click="enterHome()"
          />
          <ul class="navBarItem">
            <!-- <li class="busiz-active-sel">
              <router-link exact to="/" tag="a">首页</router-link>
            </li> -->
            <li>
              <router-link to="/aboutlanshu" exact tag="a"
                >关于兰树</router-link
              >
            </li>
            <el-dropdown>
              <li>
                <router-link to="/huaiBrand" exact tag="a"
                  >兰树品牌</router-link
                >
              </li>
              <el-dropdown-menu class="elDropdown" slot="dropdown">
                <el-dropdown-item
                  ><router-link to="/huaiBrand" tag="a"
                    >淮树</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/brand" tag="a"
                    >心清堂</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/shuiBrand" tag="a"
                    >水姻缘</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/yiBrand" tag="a"
                    >一清堂</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/zhongBrand" tag="a"
                    >Dr.CHUNG<span style="vertical-align: super;">+</span></router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/lanshuBrand" tag="a"
                    >兰树</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/zbqfBrand" tag="a"
                    >植本清方</router-link
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <li>
              <router-link to="/park" exact tag="a">智慧园区</router-link>
            </li>
            <li>
              <router-link to="/brandLanshu" exact tag="a"
                >美业菩提</router-link
              >
            </li>
            <li>
              <router-link to="/school" exact tag="a">兰树商学院</router-link>
            </li>
            
            <li>
              <router-link to="/dynamicLanshu" exact tag="a"
                >菩提基金会</router-link
              >
            </li>
           
            <li>
              <router-link to="/lanshuTrends" exact tag="a"
                >兰树动态</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="section pageBox2">
        <div class="page2Top">
          <div class="page2Left">
            <div class="leftLogo">
              <img src="../assets/newLasur/leftLogo.png" alt="" />
            </div>
            <div class="leftTitle">
              兰树商学院汇聚国内顶尖讲师团，不断推出美业高级人才专业培训课程，解决美业商业问题，提升从业人才专业素质，为合作伙伴及消费者提供更专业的美容项目及服务，倾力培养东方护肤专家。<br />
              <br />
              皮肤专业与产品专业是兰树股份屹立中国美业之根基，兰树商学院将通过系统化精细化的培训，对学员进行专业、商业等全方位培训，优化学员销售技巧，提高学员综合素养，夯实学员专业知识，提升学员服务意识，以帮助学员在中国美业之中拥有更强的竞争力，为学员赢得更多的商业机会。<br />
              <br />
              兰树商学院以培养拥有高服务意识与高专业水准的人才为己任，旨在打造东方护肤专家的摇篮。我们坚信，在我们的帮助下，您将会成为更优秀的美容师，并在中国美业中获得人生的跨越！
            </div>
          </div>
          <div class="page2Right">
            <img src="../assets/newLasur/rightLogo.png" alt="" />
          </div>
        </div>
        <div class="bottomImg">
          <img
            src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-06-40_51816.png"
            alt=""
          />
        </div>
      </div>

      <div class="section pageBox8">
        <div class="pageBoxOut2">
          <!-- 底部 -->
          <div class="footerBox">
            <div class="footerBoxHeader">
              <div class="footerBoxHeaderLeft">
                <img class="codeImg" src="../assets/code.png" alt="" />
                <span class="codeText">兰树公众号</span>
              </div>
              <div class="footerBoxHeaderRight">
                <img class="codeImg" src="../assets/xcxNew.jpg" alt="" />
                <span class="codeText">兰树云小程序</span>
              </div>
              <!-- <div class="footerBoxHeaderRight">
					  				<img class="codeImg" src="../assets/code.png" alt="">
					  				<span class="codeText">兰树客服(QQ)</span>
					  			</div> -->
            </div>
            <div class="footerMainBox">
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW"
                  >淮树旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >心清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0"
                  >水姻缘旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >一清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://drchung.tmall.com"
                  ><span>Dr.CHUNG</span>旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://zhibenqingfang.tmall.com"
                  >植本清方旗舰店</a
                >
              </li>
              <div class="lastHeader">
                <li><router-link to="/login" tag="a">登录</router-link></li>
                |
                <li><router-link to="/login" tag="a">注册</router-link></li>
              </div>
            </div>

            <div class="footerInfoBox">
              <div class="emailBox">邮箱: postermaster@lasur.com</div>
              <div class="phoneBox">电话: 0571-89025888</div>
              <div class="addressBox">
                地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
              </div>
            </div>

            <div class="footerLine"></div>
            <div class="footerBoxBottom">
              <div class="footerLeft">
                Copyright © 2023 兰树化妆品股份有限公司
                <a
                  target="_blank"
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  >浙ICP备20018890号-1</a
                >
                | <img height="16px" src="../assets/plice.png" />&nbsp;<a
                  target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740"
                  >浙公网安备 33052102000740号</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true
      }
    };
  },
  methods: {
    // over:function(){
    // 	var s = document.getElementById("zhi");
    // 	s.src="../assets/aboutLanshu/zhiC.png"
    // },

    // out:function(){
    // 	var s = document.getElementById("zhi");
    // 	s.src="../assets/aboutLanshu/zhi.png"
    // }
    enterHome() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style scoped>
.aboutContainer {
  margin: 0;
  padding: 0;
}

.pageBox1 {
  width: 100%;
  background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-27_09-27-50_20935.png)
    no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}

.pageBox2 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  /* align-items: center; */
  /* overflow: hidden; */
}

.pageBox2 img {
  width: 100%;
  height: 100%;
}

.page2Top {
  width: 100%;
  /* height: 81.93vh; */
  display: flex;
  flex-direction: row;
  /* align-items: center; */
}

.bottomImg {
  width: 100%;
  height: 22.9vh;
  position: absolute;
  bottom: 0;
}
.leftLogo {
  width: 13.18vw;
  height: 4.19vh;
}
.page2Right {
  width: 24.9375vw;
  height: 68.22vh;
  position: absolute;
  top: 5.77vh;
  right: 11.82vw;
}
.page2Left {
  position: absolute;
  top: 10.86vh;
  left: 8.4375vw;
  width: 49.27vw;
}

.leftTitle {
  margin-top: 10.11vh;
  height: 34.3vh;
  font-size: 0.99vw;
  font-family: SourceHanSansCN-Normal;
  font-weight: normal;
  color: #000000;
  line-height: 3.76vh;
}

.pageBoxOut2 {
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
}

/* 动画效果 */
@keyframes middleText {
  from {
    opacity: 0;
    left: -20em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes rightImg /* Safari 和 Chrome */ {
  from {
    opacity: 0;
    left: -20em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

/* 动画效果 */
@keyframes rightImg {
  from {
    opacity: 0;
    width: 0%;
  }
  to {
    opacity: 1;
    width: 65%;
  }
}

@-webkit-keyframes rightImg /* Safari 和 Chrome */ {
  from {
    opacity: 0;
    width: 0%;
  }
  to {
    opacity: 1;
    width: 65%;
  }
}

/* 动画效果 */
@keyframes xuanzhuan {
  from {
    opacity: 0;
    transform: rotate(270deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

@-webkit-keyframes xuanzhuan {
  from {
    opacity: 0;
    transform: rotate(270deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

/* 动画效果 */
@keyframes leftItem {
  from {
    opacity: 0;
    left: -15em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes leftItem {
  from {
    opacity: 0;
    left: -15em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

/* 精英团队动画效果 */
@keyframes team {
  from {
    opacity: 0;
    transform: rotate(120deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

@-webkit-keyframes team {
  from {
    opacity: 0;
    transform: rotate(120deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

/* footer */
.pageBox8 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  background-color: #f8f9fb;
}

.footerBox {
  width: 90%;
  /* height: 287px; */
  background: #f8f9fb;
  /* position:absolute;
	 	bottom:0; */
  margin: 0 auto;
  flex-direction: column;
  z-index: 999;
}

.footerBoxHeader {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}

.footerBoxHeaderLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footerBoxHeaderLeft,
.footerBoxHeaderRight {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
}
.footerBoxHeaderRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}

.footerBoxHeaderMiddle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.codeImg {
  width: 100%;
}

.codeText {
  font-size: 0.88em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  /* margin-top: 0em; */
}

.footerLine {
  width: 79%;
  height: 1px;
  display: flex;
  background: #000000;
  opacity: 0.1;
  margin: 0 auto;
  align-items: center;
  margin-top: 1em;
}

.footerInfoBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.emailBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
}

.phoneBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.addressBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerBoxBottom {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}

.footerLeft {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerLeft a {
  text-decoration: none;
  cursor: pointer;
  color: #666666;
}

.footerLeft a:hover {
  color: #003f98;
}

.footerMiddle {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerMiddle span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerRight {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerRight li a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}

.footerRight li {
  list-style: none;
}

.footerLast {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.lastHeader {
  display: flex;
  flex-direction: row;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin-left: 2em;
}

.lastHeader li a {
  text-decoration: none;
  font-size: 0.875rm;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 28px;
}

.lastHeader li {
  list-style: none;
}

.footerLast span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.footerMainBox {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 2em;
}

.footerShop {
  list-style: none;
  position: relative;
}

.footerShop span {
  margin-right: 10px;
}
.footerShop span::after {
  content: "+";
  display: block;
  position: absolute;
  top: -6px;
  right: 43px;
}
.footerShop a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  padding-left: 2em;
  line-height: 28px;
}

/* 导航 */
.navBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  justify-content: space-between;
  top: 0;
  /* border-bottom:1px solid rgba(255,255,255,0.2); */
  z-index: 9999;
}

.router-link-active {
  border-bottom: 3px solid #ffffff;
}

.navLogo {
  width: 10%;
  margin-left: 5em;
  cursor: pointer;
}

.navBarItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  /* margin-right: 5em; */
}

.navBarItem li {
  list-style: none;
  /*padding: 1.56em 2.5em 1.56em 2.5em;*/
  float: left;
  /* margin-left: 2em; */
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.navBarItem li a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 20px;
  padding-top: 1.3em;
  padding-bottom: 1.3em;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}

/* .elDropdown{
		margin-left: -5em;
		margin-top: -1em;
	} */

.elDropdown a {
  color: #111111;
  text-decoration: none;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/school.vue